import { AddressViewModel } from './AddressViewModel';
import { Contact } from '../Contact';


export class WaiterViewModel {
    
    constructor(u) {
        
        this.name = u.name?u.name:'';
        this.id=u.id?u.id:'';
        this.remarks=u.remarks?u.remarks:'',
        this.address =u.address&& u.address?new AddressViewModel(u.address):new AddressViewModel([]);
        this.contact =u.contact?new Contact().initialise(u.contact):new Contact().initialise([]);

    }
  }